import { render, staticRenderFns } from "./superAdminEmployeeList.vue?vue&type=template&id=20fead2a&scoped=true"
import script from "./superAdminEmployeeList.vue?vue&type=script&lang=js"
export * from "./superAdminEmployeeList.vue?vue&type=script&lang=js"
import style0 from "./superAdminEmployeeList.vue?vue&type=style&index=0&id=20fead2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fead2a",
  null
  
)

export default component.exports